<style lang="less" scoped>
.chbm{position: relative;width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0px auto;background-size:100%;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 40px;}
.main{display: flex;flex-direction: column;background: #fff;}
.formBox{width: 1180px;margin-left: -10px;margin-top: 20px;}
table {border-collapse: collapse;width: 99%;margin-left: 10px;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border: 1px solid #e2e1e1;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
.td_left {width: 200px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
.td_right {text-align: left;background-color: #fcfcfc;padding-left: 10px;}
.td_right span{font-size: 16px;}
.el-input {width: 400px;}
.el-select {width: 400px;}
/deep/.el-form-item {margin-bottom: 0;}
/deep/.el-form-item__error{top: 29%;left: 405px}
.el-button{margin-top: 20px;}
.first{margin-top: 15px;
  span{font-size: 30px;font-weight:bold;top: 10px;}
}
</style>

<template>
  <div class="chbm">
     <div class="main">
       <div class="first">
          <span>{{this.kyltTitle}}</span>
          <p>（ 注：标题前带'<span style="font-size:10px;color:red;top:0px">*</span>'为必填项 ）</p>
       </div>
       <el-form ref="form" :model="form" class="formBox" :rules="rules">
         <table>
          <tr class="tr">
            <td class="td_left">
              <span class="f_red">*</span>报名类型
            </td>
            <td class="td_right">
              <el-form-item>
                <el-radio v-model="form.type"  :label="0">报名参会</el-radio>
                <el-radio v-model="form.type"  :label="1">报名参展</el-radio>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span class="f_red">*</span>会议名称
            </td>
            <td class="td_right" v-if="this.form.type === 0">
              <el-form-item>
                <el-select v-model="form.meetingid" placeholder="请选择" class="input" @change="typeclick">
                  <el-option class="input" v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              <span style="font-size: 15px;margin-left:5px;">{{ begintime }}</span>
              </el-form-item>
            </td>
            <td class="td_right" v-if="this.form.type === 1">
              <el-form-item>
                <el-select v-model="form.meetingid" placeholder="请选择" class="input">
                  <el-option class="input" v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr" style="line-height:40px;">
            <td class="td_left">
              <span class="f_hid">*</span>会议类型
            </td>
            <td class="td_right">
              <el-checkbox-group v-model="form.meetingtype">
                <el-checkbox label="线上会议" disabled></el-checkbox>
                <el-checkbox label="线下会议" disabled></el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span class="f_red">*</span>联系人
            </td>
            <td class="td_right">
              <el-form-item prop="name">
                <el-input v-model="form.name" class="input"></el-input>
                <el-radio v-model="form.gender"  :label="0">先生</el-radio>
                <el-radio v-model="form.gender"  :label="1">女士</el-radio>
              </el-form-item>
              <el-form-item>
                
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span class="f_red">*</span>职务
            </td>
            <td class="td_right">
              <el-form-item prop="post">
                <el-input v-model="form.post" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
           <tr class="tr">
            <td class="td_left">
              <span class="f_red">*</span>单位名称
            </td>
            <td class="td_right">
              <el-form-item prop="company">
                <el-input v-model="form.company" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span class="f_red">*</span>单位地址
            </td>
            <td class="td_right">
              <el-form-item prop="address">
                <el-input v-model="form.address" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr" style="line-height:40px;">
            <td class="td_left">
              <span class="f_red">*</span>行业类别
            </td>
            <td class="td_right">
              <el-checkbox-group v-model="form.industrycategory">
                <el-checkbox label="政府和协会"></el-checkbox>
                <el-checkbox label="金融服务机构"></el-checkbox>
                <el-checkbox label="技术咨询公司"></el-checkbox>
                <el-checkbox label="矿业企业"></el-checkbox>
                <el-checkbox label="矿权交易机构"></el-checkbox>
                <el-checkbox label="矿业贸易公司"></el-checkbox>
                <el-checkbox label="检测认证"></el-checkbox>
                <el-checkbox label="地勘行业"></el-checkbox>
                <el-checkbox label="机械和设备公司"></el-checkbox>
                <el-checkbox label="教育和科研机构"></el-checkbox>
                <el-checkbox label="旅游服务"></el-checkbox>
                <el-checkbox label="媒体和出版商"></el-checkbox>
                <el-checkbox label="电子商务"></el-checkbox>
                <el-checkbox label="珠宝玉石"></el-checkbox>
                <el-checkbox label="其他"></el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
           <tr class="tr">
            <td class="td_left">
              <span class="f_red">*</span>手机号
            </td>
            <td class="td_right">
              <el-form-item prop="phone">
                <el-input v-model="form.phone" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
           <tr class="tr">
            <td class="td_left">
              <span class="f_red">*</span>电子邮箱
            </td>
            <td class="td_right">
              <el-form-item prop="email">
                <el-input v-model="form.email" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span class="f_red">*</span>国家
            </td>
            <td class="td_right">
              <el-form-item prop="country">
                <el-input v-model="form.country" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span class="f_red">*</span>报名人数
            </td>
            <td class="td_right">
              <el-form-item prop="nums">
                <el-input v-model="form.nums" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span class="f_red">*</span>参会名单
            </td>
            <td class="td_right">
              <el-form-item v-for="(item, index) in dhycList" :key="index">
                <el-input v-model="item.joinname" style="width:100px;" placeholder="姓名"></el-input>
                <el-input v-model="item.joingender" style="width:100px;" placeholder="性别"></el-input>
                <el-input v-model="item.joinpost" style="width:150px;" placeholder="职务"></el-input>
                <el-input v-model="item.joinphone" class="input" placeholder="固话/手机"></el-input>
                <i class="el-icon-circle-plus-outline" style="font-size:25px;vertical-align: middle;" @click="getDhycAry"></i>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr" v-if="this.form.type === 0">
            <td class="td_left">
              <span class="f_red">*</span>辅证材料
            </td>
            <td class="td_right" >
              <tr class="tr">
                <td class="tdright">
                  <el-upload
                    :action="url"
                    :limit="1"
                    list-type="picture-card"
                    ref="uploadPic"
                    :before-upload="beforeUploadPicture"
                    :on-preview="handlePictureCardPreview"
                    :on-success="onSuccess"
                    :on-remove="handleRemovePicture"
                    @mouseover.native="getPhoUrl"
                    :on-exceed="exceed">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img :src="dialogImageUrl" width=100% />
                  </el-dialog>
                </td>
                <td class="td_left">(单位营业执照上传)</td>
              </tr>
            </td>
          </tr>
          <tr class="tr" v-if="this.form.type === 0">
            <td class="td_left">
              <span v-if="isMandatory('meetingdemand')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>参会/参展需求
            </td>
            <td class="td_right" >
              <el-form-item>
                <el-input type="textarea" v-model="form.meetingdemand" :rows="3" style="width: 400px" placeholder="请填写参会意愿、会务需求、需要帮助解决的其他问题"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr" v-if="this.form.type === 1">
            <td class="td_left">
              <span v-if="isMandatory('meetingdemand')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>参展详情说明
            </td>
            <td class="td_right" >
              <el-form-item>
                <el-input type="textarea" v-model="form.meetingdemand" :rows="4" style="width: 400px" placeholder="请填写参展内容简介、展位需求、需要帮助解决的其他问题。更多云展位定制，请点击下方云上展厅链接"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr" v-if="this.form.type === 1">
            <td class="td_left">
              <span v-if="isMandatory('thumb')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>资料上传
            </td>
            <td class="td_right" >
              <tr class="tr">
                <td class="td_left">图片资料上传</td>
                <td class="tdright">
                  <el-upload
                    :action="url"
                    :limit="1"
                    list-type="picture-card"
                    ref="uploadPic"
                    :before-upload="beforeUploadPicture"
                    :on-preview="handlePictureCardPreview"
                    :on-success="onSuccess"
                    :on-remove="handleRemovePicture"
                    @mouseover.native="getPhoUrl"
                    :on-exceed="exceed">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img :src="dialogImageUrl" width=100% />
                  </el-dialog>
                </td>
              </tr>
              <tr class="tr">
                <td class="td_left">视频资料上传</td>
                <td>
                  <el-upload
                    class="upload-demo"
                    :action="url"
                    :limit="1"
                    :on-success="onSuccess1"
                    :on-remove="handleRemoveVideo"
                    :class="{ disabled: uploadDisabled }"
                    :before-upload="beforeUploadVideo"
                    @mouseover.native="getVidUrl"
                    :on-exceed="exceed">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <el-button style="margin-left: 15px;" size="small" type="success" @click="preview()">点击预览</el-button>
                  </el-upload>
                </td>
              </tr>
              <tr class="tr">
                <td class="td_left">文档资料上传</td>
                <td class="td_right">
                 <el-upload
                    class="upload-demo"
                    drag
                    :action= url
                    :limit="1"
                    ref="uploadPic_file"
                    :on-success="onFileSuccess"
                    :before-upload="beforeUploadFile"
                    :on-remove="handleRemoveFile"
                    :on-exceed="exceed"
                    @mouseover.native="getPdfUrl"
                    multiple><i class="el-icon-upload"></i><div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </td>
              </tr>
            </td>
          </tr>
         </table>
          <div class="submit">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <el-button type="primary" class="button1" @click="downLoad()">邀请函下载</el-button>
            </el-form-item>
          </div>
        </el-form>
     </div>
  </div>
</template>

<script>
/**
 * 李旭  2021.6.15 参会报名页面
 */
import playVideo from '../../app/method/playVideo'
export default {
  mixins: [playVideo],
  data()
  {
    let validatePhone = (rule, value, callback) =>
    {
      let regtel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (value)
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确的手机号'))
        else
          callback()
      }
      else
        callback(new Error('请输入手机号'))
    }
    let InputEmail = (rule, value, callback) =>
    {
      let regtel = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!value)
        return callback(new Error('邮箱不能为空'))
      else
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确的邮箱'))
        else
          callback()
      }
    }
    let Inputcompany = (rule, value, callback) =>
    {
      if (!value)
        return callback(new Error('公司不能为空'))
      else
        callback()
    }
    let InputName = (rule, value, callback) =>
    {
      if (!value)
        return callback(new Error('名称不能为空'))
      else
        callback()
    }
    let InputPost = (rule, value, callback) =>
    {
      if (!value)
        return callback(new Error('职务不能为空'))
      else
        callback()
    }
    let InputNums = (rule, value, callback) =>
    {
      if (!value)
        return callback(new Error('人数不能为空'))
      else
        callback()
    }
    let InputCountry = (rule, value, callback) =>
    {
      if (!value)
        return callback(new Error('国家不能为空'))
      else
        callback()
    }
    let InputAddress = (rule, value, callback) =>
    {
      if (!value)
        return callback(new Error('单位地址不能为空'))
      else
        callback()
    }
    return {
      url: '',
      dhycList: [],
      joinname: '',
      joingender: '',
      joinpost: '',
      joinphone: '',
      form: {
        type: 0,
        meetingid: '',
        meetingtype: [],
        name: '',
        gender: null,
        post: '',
        company: '',
        phone: '',
        email: '',
        country: '',
        address: '',
        industrycategory: [],
        nums: '',
        meetingdemand: '',
        video: '',
        thumb: '',
        file: ''
      },
      options: [{
        value: 0,
        label: '报名参会'
      }, {
        value: 1,
        label: '报名参展'
      }],
      userPhone: '',
      options1: [],
      options2: [],
      begintime: '',
      //表名
      tabname: 'dmcn_kyltenjoy',
      //fld表数据
      fldData: [],
      dialogVisible: false,
      dialogVisible1: false,
      dialogFormVisible: false,
      //预览路径
      dialogImageUrl: '',
      uploadDisabled: false,
      kyltTitle: '',
      rules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        email: [{ validator: InputEmail, trigger: 'blur' }],
        company: [{ validator: Inputcompany, trigger: 'blur' }],
        name: [{ validator: InputName, trigger: 'blur' }],
        post: [{ validator: InputPost, trigger: 'blur' }],
        nums: [{ validator: InputNums, trigger: 'blur' }],
        country: [{ validator: InputCountry, trigger: 'blur' }],
        address: [{ validator: InputAddress, trigger: 'blur' }]
      }
    }
  },
  async created()
  {
    this.fldData = await window.public.validation(this.tabname)

    this.getList()
    this.getDhycAry()
    this.getoptions()
    this.getUserPe()
  },
  methods: {
    onSubmit()
    {
      let parameter = []
      
      // 用户报名短信通知管理员数据
      let userNotice = {
        cmd: 'smsNotice',
        _major: 99,
        _minor: 4,
        phone: `${this.userPhone}`,
        key: 'signupNotice'
      }
      // 用户报名短信通知用户数据
      let submitDate = {
        cmd: 'smsNotice',
        _major: 99,
        _minor: 4,
        phone: this.form.phone,
        key: 'signupSubmit'
      }
      let regtel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      let regtels = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!localStorage.getItem('username'))
      {
        this.$message({message: '请您先登录', type: 'error', customClass: 'mzindex'})
        this.$router.push('/loginIndex')//拦截成功后需要跳转的页面
      }
      else
      {
        this.$refs.form.validate(valid =>
        {
          if (valid)
          {
            let obj = {
              cmd: 'add',
              _major: 11,
              _minor: 106,
              retAtt: 1,
              type: this.form.type,
              meetingid: this.form.meetingid,
              meetingtype: this.form.meetingtype.toString(),
              name: this.form.name,
              gender: this.form.gender,
              company: this.form.company,
              address: this.form.address,
              industrycategory: this.form.industrycategory.toString(),
              phone: this.form.phone,
              post: this.form.post,
              email: this.form.email,
              nums: this.form.nums,
              country: this.form.country,
              meetingdemand: this.form.meetingdemand,
              video: this.form.video,
              thumb: this.form.thumb,
              file: this.form.pdf,
              examine: 0,
              username: localStorage.getItem('username'),
              addtime: (Date.parse(new Date()) / 1000)
            }
            window.post.getPost(obj).then(ret =>
            {
              if (ret.ret === 0)
              {
                this.dhycList.forEach(e =>
                {
                  parameter.push({glid: ret.id, joinname: e.joinname, joingender: e.joingender, joinpost: e.joinpost, joinphone: e.joinphone})
                })
                let param = {
                  cmd: 'adds',
                  _major: 11,
                  _minor: 120,
                  json: JSON.stringify(parameter)
                }
                window.post.getPost(param).then((data) =>
                {
                  if (data.ret === 0)
                  {
                    window.post.getDmSvr(userNotice).then((ret) =>
                    {
                      if (ret.ret === 0)
                      {
                        window.post.getDmSvr(submitDate).then((ret) =>
                        {
                          if (ret.ret === 0)
                            this.$message({message: '报名成功', type: 'success', customClass: 'mzindex'})
                          else
                            this.$message({message: '短信通知用户错误', type: 'error', customClass: 'mzindex'})
                        })
                      }
                      else
                        this.$message({message: '短信通知管理员错误', type: 'error', customClass: 'mzindex'})
                    })
                  }
                  else
                    this.$message({message: '参会名单填写有误', type: 'error', customClass: 'mzindex'})
                })
                if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
                  this.$router.push({path: '/PromoinApp'})
                else
                  this.$router.push({path: '/Promoin'})
              }
              else
                this.$message({message: '报名失败', type: 'error', customClass: 'mzindex'})
            })
          }
          else if (!regtel.test(this.form.phone))
            this.$message({message: '请填写正确的手机号', type: 'warning', customClass: 'mzindex'})
          else if (!regtels.test(this.form.email))
            this.$message({message: '请填写正确的邮箱', type: 'warning', customClass: 'mzindex'})
        })
      }
    },
    // 获取需要发送管理员的手机号
    getUserPe()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 117, _exp: 'id>0', orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.userPhone = ''
        ret.forEach(item =>
        {
          if (item === ret[ret.length - 1])
          
            this.userPhone += item.phone
          else
            this.userPhone += item.phone + ','
        })
      })
    },
    // 下载邀请函
    downLoad()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 110, _exp: 'id>0', orderby: 'id DESC', init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret[0].total !== 0)

          window.open(ret[0].data[0].pdf, '_blank')
        else

          this.$message.error('邀请函还未上传，请联系管理员')
      })
    },
    typeclick(val)
    {
      let obj = {
        cmd: 'query',
        _major: 11,
        _minor: 105,
        _exp: `id = '${val}'`
      }
      window.post.getPost(obj).then(ret =>
      {
        if (ret.length > 0)
        {
          this.begintime = ret[0].begintime
          this.form.meetingtype = ret[0].difference.split(',')
        }
      })
    },
    getoptions()
    {
      let obj = {
        cmd: 'query',
        _major: 11,
        _minor: 105,
        _exp: 'id > 0 and status = 0',
        orderby: 'orders Asc'
      }
      window.post.getPost(obj).then(ret =>
      {
        this.options1 = []
        this.options2 = []
        ret.forEach(item =>
        {
          if (item.type === 0)
          {
            this.options1.push(
              {
                value: item.id,
                label: item.name,
                begintime: item.begintime
              }
            )
          }
          else if (item.type === 1)
          {
            this.options2.push(
              {
                value: item.id,
                label: item.name,
                begintime: item.begintime
              }
            )
          }
        })
      })
    },
    getDhycAry()
    {
      this.dhycList.push({joinname: '', joingender: '', joinpost: '', joinphone: ''})
    },
    getList()
    {
      let obj = {
        cmd: 'query',
        _major: 11,
        _minor: 111,
        _exp: 'id > 0'
      }
      window.post.getPost(obj).then(ret =>
      {
        this.kyltTitle = ret[0].name
        this.thumb = ret[0].thumb
      })
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    /**
     * 图片上传内容
      */
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    /**
     * 视频上传内容
    */
    getVidUrl()
    {
      let that = this
      window.public.onUploadVideo(that)
    },
    //上传视频
    onSuccess1(response)
    {
      let that = this
      window.public.onVideoSuccess(response, that)
    },
    //视频上传之前的钩子
    beforeUploadVideo(file)
    {
      let that = this
      window.public.beforeUploadVideo(file, that)
    },
    handleRemoveVideo(fileList)
    {
      let that = this
      window.public.handleRemoveVideo(fileList, that)
    },
    /**
     * 文件上传内容
    */
    //获取文件url地址
    getPdfUrl()
    {
      let that = this
      window.public.onUploadFile(that)
    },
    //文件上传之前的钩子
    beforeUploadFile(file)
    {
      return true
    },
    //pdf文件上载成功
    onFileSuccess(response)
    {
      let that = this
      window.public.onFileSuccess(response, that)
    },
    //删除文件
    handleRemoveFile(fileList)
    {
      let that = this
      window.public.handleRemoveFile(fileList, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/MeetingEnroll.vue